<div class="container" *transloco="let t">
  <div class="row">

    <div class="col-md-8 p-2">
      @if (!loading && !hubs?.length) {
        <p><span>{{t('common.none_yet')}}</span></p>
      }
      @if (loading) {
        <multisite-loader-globe-animation-detail [width]="100" [height]="100">
        </multisite-loader-globe-animation-detail>
      }

      @for (hub of hubsAsContentItems; track hub) {
        <a [routerLink]="[hub.slug]">
          <card-banner-list-item-promo [content]="hub"
          [imageTransformations]="'w_1000,c_fill,ar_16:9/'"></card-banner-list-item-promo>
        </a>
      }

    </div>
    <div class="col-md-4 p-2">
      @if (hubsAsContentItems?.length === 1) {
        <button class="btn btn-success w-100"  [routerLink]="[hubsAsContentItems[0].slug]">{{t('common.go')}} <i class="pl-2 fa-solid fa-arrow-right"></i></button>
      }
      <button class="btn btn-primary w-100 my-3" [routerLink]="['new']" routerLinkActive="router-link-active">
        {{t('common.new')}} <i class="pl-2 fa-solid fa-plus"></i>
      </button>
      @for (link of links; track link) {
        <multisite-link-type-six
          [imageTransformations]="'w_100,c_thumb/'"
          [titleText]="link.label"
          [description]="link.description"
          [image]="link.image"
          [cta_label]="link.cta_label"
          [cta_type]="link.cta_type"
          [url]="link.url"
          >
        </multisite-link-type-six>
      }
    </div>
  </div>
</div>